import React from 'react'
import Button from '@bt-react/components/Button'
import { IconType } from '@bt-react/components/Icon'
import Modal from '@bt-react/components/Modal'

const RescheduledModal = props => {

  const onConfirm = () => {

    props.setRescheduledViewed() // check they are set before calling lodash
    props.hideRescheduleModal() // check they are set before calling lodash

  }

  return <Modal
    isOpen={true}
    concise={true}
  >
    <Modal.Header
      dataBdd={`talks-dialog-rescheduled-header`}
      hideBorder={true}
    >
      This talk has been rescheduled
    </Modal.Header>
    <Modal.Body
      dataBdd={`talks-dialog-rescheduled-body`}
    >
      <p>The date and time displayed in this presenter screen will be updated shortly</p>
      <p>If you require more details, please contact the organizer.</p>
    </Modal.Body>
    <Modal.Footer>
      <Button
        color={IconType.colour.primary}
        text="OK"
        dataBdd="talks-button-confirm"
        onClick={onConfirm}
      />
    </Modal.Footer>
  </Modal>

}

export default RescheduledModal
